export default __webpack_public_path__ + "static/media/Animals06.05bc8d71.jpg";